import React, { useEffect, useState } from "react";
import TrainingList from "./TrainingList";
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const TrainingAllList = () => {
    const [loginId, setLoginId] = useState('');

    useEffect(() => {
        let id = localStorage.getItem("userId");
        setLoginId(id);
    }, []);

    console.log(loginId !== '' ? "heeeeeeeeeeeeeeeeeeee" : "meeeeeeeeeeeeeeeeeeee");

    return (
        <>
            {loginId !== '' ? (
                <>
                    <IdleTimeOutHandler />
                    <TrainingList />
                    {console.log("Inside <IdleTimeOutHandler /> and <TrainingList /> block")}
                </>
            ) : (
                <>
                    <TrainingList />
                    {console.log("Inside <TrainingList /> block")}
                </>
            )}
        </>
    )
}

export default TrainingAllList;
